// packages imports
import { Divider, Grid, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'

// components imports
import { CustomController } from '../../../common/CustomController'

// others
import { DiscountType } from '../../../../../generated'

const DiscountForm = () => {
  const { watch } = useFormContext()
  const discountType = watch('billing.discountType')

  return (
    <Grid container item spacing={2.5}>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1" textTransform="uppercase" fontWeight={700}>
          Discount
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CustomController
          fieldType="number"
          controllerName="billing.discountPercentage"
          controllerLabel="Percentage (%)"
          isDisabled={discountType !== DiscountType.Percentage}
          sx={{ my: 0 }}
        />
      </Grid>
    </Grid>
  )
}

export default DiscountForm
